import * as THREE from 'three';

export interface ClassificationEntry {
  visible: boolean;
  name: string;
  color: [number, number, number, number];
}

export interface ClassificationSchemeType {
  DEFAULT: Record<number | 'DEFAULT', ClassificationEntry>;
  RANDOM: Record<number | 'DEFAULT', THREE.Vector4>;
}

export const ClassificationScheme: ClassificationSchemeType = {
  DEFAULT: {
    0: { visible: true, name: 'never classified', color: [0.5, 0.5, 0.5, 1.0] },
    1: { visible: true, name: 'unclassified', color: [0.5, 0.5, 0.5, 1.0] },
    2: { visible: true, name: 'ground', color: [0.63, 0.32, 0.18, 1.0] },
    3: { visible: true, name: 'low vegetation', color: [0.0, 1.0, 0.0, 1.0] },
    4: { visible: true, name: 'medium vegetation', color: [0.0, 0.8, 0.0, 1.0] },
    5: { visible: true, name: 'high vegetation', color: [0.0, 0.6, 0.0, 1.0] },
    6: { visible: true, name: 'building', color: [0.0, 0.8, 0.8, 1.0] },
    7: { visible: true, name: 'low point (noise)', color: [1.0, 0.0, 1.0, 1.0] },
    8: { visible: true, name: 'key-point', color: [0.6, 0.0, 1.0, 1.0] },
    9: { visible: true, name: 'water', color: [0.0, 0.5, 1.0, 1.0] },
    12: { visible: true, name: 'overlap', color: [0.8, 0.8, 0.8, 1.0] },
    14: { visible: true, name: 'wire conductor', color: [1.0, 0.25, 0.75, 1.0] },
    15: { visible: true, name: 'tower', color: [0.0, 0.0, 1.0, 1.0] },
    90: { visible: true, name: 'Low ≤ 5.0 m', color: [1.0, 1.0, 0.0, 1.0] },
    91: { visible: true, name: 'High ≤ 3.0 m', color: [1.0, 0.5, 0.0, 1.0] },
    92: { visible: true, name: 'Critical ≤ 1.0 m', color: [1.0, 0.0, 0.0, 1.0] },
    DEFAULT: { visible: true, name: 'default', color: [0.3, 0.6, 0.6, 0.5] },
  },
} as unknown as ClassificationSchemeType;

Object.defineProperty(ClassificationScheme, 'RANDOM', {
  get() {
    const scheme: Record<number | string, THREE.Vector4> = {};

    for (let i = 0; i <= 255; i++) {
      scheme[i] = new THREE.Vector4(Math.random(), Math.random(), Math.random());
    }

    scheme['DEFAULT'] = new THREE.Vector4(Math.random(), Math.random(), Math.random());

    return scheme;
  },
});
